import { userHasPermission } from "../../../../../utils/accessTree";
import permissionCodes from "../../../../../utils/permissionCodes";

const { COMISIONES_V2_MULTICLUB: MULTICLUB } = permissionCodes;

export const hiddenIfNotBusquedaPeriodo = formValue => !!formValue.tipoBusqueda;

export const hiddenIfNotBusquedaFactura = formValue =>
  formValue.tipoBusqueda !== "FACTURA";

export const requiredIfBusquedaPeriodo = {
  validator: (value, formValue) => !formValue.tipoBusqueda && !value,
  message: () => "Campo obligatorio"
};

export const requiredClub = {
  validator: (value, formValue) =>
    !formValue.tipoBusqueda && !userHasPermission(MULTICLUB) && !value,
  message: () => "Campo obligatorio"
};

export const requiredIfBusquedaFactura = {
  validator: (value, formValue) =>
    formValue.tipoBusqueda === "FACTURA" && !value,
  message: () => "Campo obligatorio"
};
